import React from 'react';

import { SVGPropsType } from 'src/types';

function TransferCircled(props: SVGPropsType) {
    const { stroke, fill, onClick, style, className } = props;

    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <rect width="36" height="36" rx="18" fill={fill} />
            <path
                d="M25.4998 20.5L22.1665 23.8333"
                stroke={stroke}
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 20.5H25.5"
                stroke={stroke}
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 15.5001L13.8333 12.1667"
                stroke={stroke}
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.5 15.5H10.5"
                stroke={stroke}
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default TransferCircled;
